import { randomNumber } from '../../../../utilities'
import { ChildbirthOBConstants } from './childbirthOB.constants'
import { IChildbirthOBAction, IChildbirthOBState } from './childbirthOB.types'

export const initialChildbirthOBState: IChildbirthOBState = {
  action: null,
  fetalHR: '',
  contractionsFreq: '',
  contractionsDur: '',
  variability: null,
  accelerations: null,
  deceleration: null,
  uCStrength: null,
  dTR: null,
  size: '',
  assessedBy: null,
  procedureComplications: [],
  response: null,
  responsePNNV: null,
  authorization: null,
  comments: '',
  addToTimeline: false,
  updateInputRows: false,
  key: randomNumber().toString(),
  date: '',
  time: '',
  successfulAttempt: true,
  pta: false,
  attempts: '1',
  type: 'Childbirth',
  rolePerforming: null,
  rolePerformingPNNV: null,
  procedurePerformedByAnotherUnit: null,
  procedurePerformedByAnotherUnitPNNV: null,
  isEkgImport: null,
  nemsisCode: null,
}

export function childbirthOBReducer(
  state: IChildbirthOBState = initialChildbirthOBState,
  action: IChildbirthOBAction
): IChildbirthOBState {
  switch (action.type) {
    case ChildbirthOBConstants.SET_ACTION:
      return { ...state, action: action.action }
    case ChildbirthOBConstants.SET_FETAL_HR:
      return { ...state, fetalHR: action.fetalHR }
    case ChildbirthOBConstants.SET_CONTRACTIONS_FREQ:
      return { ...state, contractionsFreq: action.contractionsFreq }
    case ChildbirthOBConstants.SET_CONTRACTIONS_DUR:
      return { ...state, contractionsDur: action.contractionsDur }
    case ChildbirthOBConstants.SET_VARIABILITY:
      return { ...state, variability: action.variability }
    case ChildbirthOBConstants.SET_ACCELERATIONS:
      return { ...state, accelerations: action.accelerations }
    case ChildbirthOBConstants.SET_DECELERATION:
      return { ...state, deceleration: action.deceleration }
    case ChildbirthOBConstants.SET_UC_STRENGTH:
      return { ...state, uCStrength: action.uCStrength }
    case ChildbirthOBConstants.SET_DTR:
      return { ...state, dTR: action.dTR }
    case ChildbirthOBConstants.SET_SIZE:
      return { ...state, size: action.size }
    case ChildbirthOBConstants.SET_DATE_TIME:
      return { ...state, time: action.time, date: action.date }
    case ChildbirthOBConstants.SET_DATE:
      return { ...state, date: action.date }
    case ChildbirthOBConstants.SET_TIME:
      return { ...state, time: action.time }
    case ChildbirthOBConstants.SET_ASSESSED_BY:
      return { ...state, assessedBy: action.assessedBy }
    case ChildbirthOBConstants.SET_SUCCESSFUL_ATTEMPT:
      return { ...state, successfulAttempt: action.successfulAttempt }
    case ChildbirthOBConstants.SET_PTA:
      return { ...state, pta: action.pta }
    case ChildbirthOBConstants.SET_PROCEDURE_COMPLICATIONS:
      return { ...state, procedureComplications: action.procedureComplications }
    case ChildbirthOBConstants.SET_RESPONSE:
      return { ...state, response: action.response }
    case ChildbirthOBConstants.SET_RESPONSE_PNNV:
      return { ...state, responsePNNV: action.responsePNNV }
    case ChildbirthOBConstants.SET_AUTHORIZATION:
      return { ...state, authorization: action.authorization }
    case ChildbirthOBConstants.SET_COMMENTS:
      return { ...state, comments: action.comments }
    case ChildbirthOBConstants.SET_ADD_TO_TIMELINE:
      return { ...state, addToTimeline: action.addToTimeline }
    case ChildbirthOBConstants.SET_UPDATE_INPUT_ROWS:
      return { ...state, updateInputRows: action.updateInputRows }
    case ChildbirthOBConstants.SET_STATE:
      return { ...action.childbirthOBState, updateInputRows: true }
    case ChildbirthOBConstants.SET_ATTEMPTS:
      return { ...state, attempts: action.attempts }
    case ChildbirthOBConstants.SET_ROLE_PERFORMING:
      return { ...state, rolePerforming: action.rolePerforming }
    case ChildbirthOBConstants.SET_ROLE_PERFORMING_PNNV:
      return { ...state, rolePerformingPNNV: action.rolePerformingPNNV }
    case ChildbirthOBConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT:
      return { ...state, procedurePerformedByAnotherUnit: action.procedurePerformedByAnotherUnit }
    case ChildbirthOBConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV:
      return { ...state, procedurePerformedByAnotherUnitPNNV: action.procedurePerformedByAnotherUnitPNNV }
    case ChildbirthOBConstants.RESET_STATE:
      return {
        action: null,
        fetalHR: '',
        contractionsFreq: '',
        contractionsDur: '',
        variability: null,
        accelerations: null,
        deceleration: null,
        uCStrength: null,
        dTR: null,
        size: '',
        assessedBy: null,
        procedureComplications: [],
        response: null,
        responsePNNV: null,
        authorization: null,
        comments: '',
        addToTimeline: false,
        updateInputRows: true,
        key: randomNumber().toString(),
        date: '',
        time: '',
        successfulAttempt: true,
        pta: false,
        attempts: '1',
        type: 'Childbirth',
        rolePerforming: null,
        rolePerformingPNNV: null,
        procedurePerformedByAnotherUnit: null,
        procedurePerformedByAnotherUnitPNNV: null,
        isEkgImport: null,
        nemsisCode: null,
      }
    default:
      return state
  }
}
